import { Button, Grid2 } from '@mui/material';
import React, { PropsWithoutRef, ReactElement } from 'react';

type ModelFooterProps = {
  confirmButton?: ReactElement;
  cancelButtonText: string;
  handleClickCancel: () => void;
};

const ModelFooter = ({
  cancelButtonText,
  confirmButton,
  handleClickCancel,
}: PropsWithoutRef<ModelFooterProps>) => (
  <Grid2 container sx={{ justifyContent: 'right' }}>
    <Grid2>
      <Button onClick={handleClickCancel}>{cancelButtonText}</Button>
    </Grid2>
    {confirmButton && <Grid2>{confirmButton}</Grid2>}
  </Grid2>
);

export default ModelFooter;
